<a [routerLink]="product?.url"
   [attr.urlll]="product?.url"
   [attr.id]="id"
   ga4SelectItem
   [items]="[product] | mapGA4Items"
   [name]="listName?.length > 0 ? listName : null">
    <span class="media">
        <img [alt]="product?.name"
             [use]="image"
             loading="eager"
             role="presentation"
             fetchPriority = "high"
             size="product-card"
             fit="width"
             [srcset]="srcset" />
             @for(indicator of product?.indicators|indicatorSort; track indicator.text) {
                <div class="indicator"
                    [attr.length]="indicator?.text?.length"
                    [attr.position]="indicator.display"
                    [style.color]="indicator?.textColor"
                    [style.backgroundColor]="indicator?.backgroundColor">{{ indicator.text }}</div>
                }
             @for(discount of product?.price?.discounts; track discount.type) {
                <div class="indicator discount"
                    [class.long-amount]="discount.amount > 999"
                    [class.very-long-amount]="discount.amount > 99999"
                    position="Top">-{{ discount.type == 'Amount' ?  (discount | price) : discount.amount+'%' }}</div>
                }

    </span>
    <span class="name">{{ product?.name }}</span>
    <span class="description">{{ product?.shortDescription }}</span>
    <div class="price">
        <span class="list-price"
              [attr.pretranslate]="'PRODUCT_CARD.LIST_PRICE'|translate"> @if(product?.price?.discounts?.length > 0) { {{ product?.price?.listPrice | price }} } </span>
        <span class="sales-price"
              [attr.posttranslate]="'PRODUCT_CARD.SALES_PRICE_'+vatState|translate">{{ product?.price?.salesPrice | price }}</span>
        <span class="discount-price"
              [attr.pretranslate]="'PRODUCT_CARD.DISCOUNT_PRICE'|translate">@if (product?.price?.listPrice?.amount > product?.price?.salesPrice?.amount) {{{ {amount:product?.price?.listPrice?.amount - product?.price?.salesPrice?.amount, currency:product?.price?.salesPrice.currency} | price }} } </span>
    </div>
</a>
